import { ChoiceChips } from '@platform/design-system';
import { PERIOD_PRESETS, type PeriodPreset } from './report-period.ts';
import { usePageContext } from './usePageContext.ts';

export type PeriodChipsProps = {
  value: PeriodPreset;
  onChange: (preset: PeriodPreset) => void;
};

export const PeriodChips = ({ value, onChange }: PeriodChipsProps) => {
  const { t, locale } = usePageContext();
  return (
    <ChoiceChips
      legend={t('period.legend')}
      hideLegend
      locale={locale}
      value={value}
      choices={PERIOD_PRESETS.map((preset) => ({ value: preset, label: t(`period.${preset}`) }))}
      onChange={onChange}
    />
  );
};
